import React, { useState } from "react";
import classes from "./Subscribe.module.css";

const Subscribe = () => {
  const [subLoading, setSubLoading] = useState(false);

  // const handleSubmit = () => {
  //   if (subLoading) return;
  //   setSubLoading(true);

  //   const redirectUrl = "https://dsdp-cg.safaricom.com/consent-gateway/001023837256";

  //   window.location.replace(redirectUrl);
  // };
  const handleSubmit = () => {
  if (subLoading) return;
  setSubLoading(true);

  // Get ext_ref from current URL
  const params = new URLSearchParams(window.location.search);
  const ext_ref = params.get("ext_ref") || "";

  // Append ext_ref to consent URL
  const redirectUrl =
    `https://dsdp-cg.safaricom.com/consent-gateway/001023837256?ext_ref=${encodeURIComponent(ext_ref)}`;

  window.location.replace(redirectUrl);
};

  return (
    <div className={classes.container}>
      <div className={classes.formBox}>
        {/* LOGO */}
        <div className={classes.logoBox}>
          <img src="/ai-logo.png" alt="Logo" className={classes.logo} />
        </div>

        {/* TITLE */}
        <h1 className={classes.title}>DigitizeAI</h1>

        {/* DESCRIPTION */}
        <p className={classes.description}>
          Unlimited Kids Videos
          <br />
          Fun Learning Experience
        </p>

        {/* PRICE */}
        <h2 className={classes.price}>Price 15KSH/Daily</h2>

        {/* BUTTON */}
        <button
          type="button"
          onClick={handleSubmit}
          disabled={subLoading}
          style={{ touchAction: "manipulation" }}
          className={`${classes.button} ${
            subLoading ? classes.disabledButton : ""
          }`}
        >
          {subLoading ? "Redirecting..." : "Subscribe"}
        </button>
      </div>
    </div>
  );
};

export default Subscribe;